export const commonTableStyles = {
  muiTablePaperProps: { elevation: 0, sx: { borderRadius: 0, border: 'none', minHeight: 'auto' } },
  muiTableContainerProps: {
    sx: { 
      minHeight: 'auto',
      overflowX: 'auto',
      "& .MuiTableRow-root": { boxShadow: "none !important" },
    }
  },
  muiTableBodyProps: {
    sx: { minHeight: 'auto' }
  },
  muiTableHeadCellProps: {
    sx: {
      whiteSpace: 'normal',
      position: 'sticky',
      top: 0,
      zIndex: 2,
      backgroundColor: '#f8fafc',
      fontWeight: 600,
      color: '#334155',
      
      letterSpacing: 'normal',
      textTransform: 'none',
      py: 1,
      borderBottom: '1px solid #e2e8f0',
      '&:first-of-type': {
        paddingLeft: '24px',
      },
      '& .Mui-TableHeadCell-Content': {
        whiteSpace: 'normal',
      },
      '& .Mui-TableHeadCell-Content-Labels': {
        whiteSpace: 'normal',
      },
      '& .Mui-TableHeadCell-Content-Wrapper': {
        whiteSpace: 'normal',
        wordBreak: 'normal',
        overflowWrap: 'normal',
        lineHeight: 1.2,
        width: '100%',
      },
    },
  },
  muiTableBodyCellProps: { 
    sx: { 
      whiteSpace: 'nowrap',
      
      color: '#1e293b',
      fontWeight: 400,
      py: 0.75,
      borderBottom: '1px solid #f1f5f9'
    } 
  }
};
